import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f414005"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bill-to-card" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "blurb" }

import { DxCheckBox } from "devextreme-vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'bill-to-card',
  props: {
  /**
   * Indicates whether the component is checked.
   * @type {boolean}
   * @default true
   * @required
   */
  checked: {
    type: Boolean,
    required: true,
  },

  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },

  /**
   * A blurb description related to the component.
   * @type {string}
   * @default ''
   */
  blurb: {
    type: String,
    default: "",
  },
},
  emits: ["update:checked"],
  setup(__props, { emit }) {

const props = __props;





const checkedComputed = computed({
  get: () => props.checked,
  set: (value: boolean) => emit("update:checked", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.blurb), 1),
      _createVNode(_unref(DxCheckBox), {
        value: checkedComputed.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((checkedComputed).value = $event))
      }, null, 8, ["value"])
    ])
  ]))
}
}

})